import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { CurrencyUtils } from 'PMT/utils';

// -- entities
import { OrderProduct, OrderProductOption } from 'PMT/entities/order';
import { Product, ProductOption } from 'PMT/entities/menu';

// -- views
import OrderProductOptionView from './OrderProductOptionView';

export default class OrderProductView extends Component {

  static defaultProps = {
    quantity: 0
  };

  static propTypes = {
    orderProduct: PropTypes.objectOf(OrderProduct).isRequired,

    onMenu: PropTypes.bool.isRequired,

    quantity: PropTypes.number,

    currencyCode: PropTypes.string,
  };

  get orderProduct(): OrderProduct {
    return this.props.orderProduct;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }

  //
  // Renderers
  //

  renderHeader() {
    const price = (this.props.onMenu ? this.orderProduct.getTotalAdditionnalPriceForMenu()
    : this.orderProduct.getTotalPrice()) * this.props.quantity;

    const className = classNames('order_product_view__header', {
      'order_product_view__header_with_price': price > 0 && !this.props.onMenu
    })

    return (
      <div className={className}>
        {this.renderQuantity()}
        {this.renderName()}
        {this.renderPrice(price)}
      </div>
    );
  }

  renderQuantity() {
    const className = classNames('order_product_view__quantity', {
      order_product_view__quantity_multiple: this.props.quantity > 1
    })
    return (
      <div className={className}>
        {this.props.quantity > 0 &&
          <span>{this.props.quantity}x</span>
        }
      </div>
    );
  }

  renderName() {
    return (
      <div className="order_product_view__name">
        {this.orderProduct.name}
      </div>
    );
  }

  renderPrice(price: number) {
    if (this.props.onMenu) {
      return (null);
    }

    if (price > 0) {
      return (
        <div className="order_product_view__price">
          {CurrencyUtils.formatPriceWithCurrency(price, this.currencyCode)}
        </div>
      );
    }

    return (null);
  }

  renderComment() {
    if (_.isEmpty(this.orderProduct.comment)) {
      return (null);
    }

    return (
      <div className="order_product_view__comment">
        {this.orderProduct.comment}
      </div>
    );
  }

  renderOptions() {
    return (
      <div  className="order_product_view__options">
        {this.orderProduct.options.map((orderProductOption: OrderProductOption, index: number) => {
          return (
            <OrderProductOptionView
              key={`${orderProductOption.id}_${index}`}
              orderProductOption={orderProductOption}
            />
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div className='order_product_view'>
        {this.renderHeader()}
        {this.renderComment()}

        {this.renderOptions()}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/components/order/orderDetailModal/OrderProductView.js